export default __webpack_public_path__ + "static/statistic-e74a1e4e15f9774d688faba1ecd6cef1.png";